import { render } from "./registerCase.vue?vue&type=template&id=e678fd64&scoped=true"
import script from "./registerCase.vue?vue&type=script&lang=js"
export * from "./registerCase.vue?vue&type=script&lang=js"

import "./registerCase.vue?vue&type=style&index=0&id=e678fd64&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/itibo/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e678fd64"]])

export default __exports__